export default __webpack_public_path__ + "static/media/envelope.a339f5c5.svg";